<template>
  <div class="formCom" >
    <div class="form-btn">
      <div class="name">
        <span class="val-error" v-if="errorCase == 'already_registered'">
        Kit ID {{ convertKitId(this.kit_id) }} has already been activated, please 
        <router-link to="/login" tag="a" class="login-link">
             sign in</router-link
          > to continue.
      </span>
      <span class="val-error " v-if="errorCase == 'exist_validation'">
         Kit ID {{ convertKitId(this.kit_id) }} is not available. Please 
        <a :href="contact_link" class="login-link">contact support.</a>
      </span>
      </div>
      <button class="saveBtn" @click="done">Ok</button>
    </div>
  </div>
</template>

<script>
import { parseAndConvertKitId } from "../mixins/parseAndConvertKitId";
export default {
  name:'KitIdAlert',
  mixins: [parseAndConvertKitId],
  props: ["message","kit_id"],  
  data() {
    return {
        errorCase: null,
        contact_link: 'https://www.gotmold.com/#contact-us',
    }
  },
  methods: {
    done(){
      if(this.errorCase == 'already_registered'){
        this.$router.push({ path: "/login" });
      } else {
        window.location.href = this.contact_link;
      }
    }
  },
  mounted() {
    if(this.message == "already_registered"){
        this.errorCase = 'already_registered';
    } else {
        this.errorCase = 'exist_validation';
    }
  }
};
</script>

<style scoped>
.formCom {
  background-color: rgba(219, 230, 241, 0.5);
  position: fixed;
  width: 100%;
  height: 100%;
  display: flex;
  justify-content: center;
  align-items: center;
  left: 0;
  top: 0;
  z-index: 99;
}
.form {
  padding: 30px;
  background-color: #fff;
  max-width: 410px;
  width: 100%;
  position: relative;
  z-index: 1;
  border-radius: 10px;
}
.form-btn {
  padding: 30px;
  background-color: #fff;
  max-width: 710px;
  width: 100%;
  position: relative;
  z-index: 1;
  border-radius: 10px;
}
.button-wrap {
  width: 50%;
  margin: 0 auto 15px auto;
  display: flex;
  justify-content: space-around;
}
.name {
  color: #005eb8;
  font-size: 24px;
  margin: 10px 0px 60px 0px !important;
  text-align: center;
  font-family: TTNormsMedium, sans-serif;
}
.btn {
  display: flex;
  align-items: center;
  justify-content: center;
  width: 20px;
  height: 20px;
  padding: 0;
  border: 1px solid transparent;
  cursor: pointer;
}
.btn img {
  max-width: 100%;
  height: 100%;
}
.saveBtn {
  outline: none;
  border: 1px solid transparent;
  color: #fff;
  width: 150px;
  height: 45px;
  margin: 25px auto 0 auto;
  display: flex;
  align-items: center;
  justify-content: center;
  cursor: pointer;
  background-color: #62b039;
  border-radius: 25px;
  font-size: 18px;
  transition: all 0.5s linear;
  font-family: TTNormsMedium, sans-serif;
}
.val-error{
    color: #E10E49;
    font-size: 18px;
    font-family: TTNormsLight, sans-serif;
    position: absolute;
    display: inline-block;
    left: 0;
    width: 100%;
    text-align: center;
}
</style>
